import { useTranslation } from 'react-i18next'

/*
 * Translation hook for the human-made badge. It deliberately does NOT use the app-wide
 * hooks/useTranslation, for two reasons:
 *
 * 1. That hook writes its namespace's language back to the single global i18next instance.
 *    The badge is passive chrome rendered on ~12 surfaces, several of which also render
 *    skill-bite copy, and the two writes would race - whichever changeLanguage settles last
 *    wins, so the badge could flip a skill-bite page into the article language. The badge
 *    only ever reads the language that is already active.
 *
 * 2. useSuspense is off. The 'content' bundle is preloaded in src/i18n.js, but if it is ever
 *    not ready the badge must not throw a promise: most of its placements have no <Suspense>
 *    boundary above them, and on a discrete update React turns that into "A component
 *    suspended while responding to synchronous input", which reaches the root error boundary
 *    and blanks the app. Callers render nothing until `ready`.
 */
const useBadgeTranslation = () => useTranslation('content', { useSuspense: false })

export default useBadgeTranslation
